import './preload'
import Vue from 'vue'
import router from './router'
import getStore from './store'
import './quasar'
import './styles/tailwind.generated.css'
import App from './App.vue'
import './i18n/index'

Vue.config.productionTip = false

new Vue({
  router,
  store: getStore(),
  render: (h) => h(App)
}).$mount('#app')
